<div class="sp-intel-shell">

  <sp-header></sp-header>

  <div class="sp-intel-body">

    <!-- ─────────────── LEFT RAIL: HISTORY ─────────────── -->
    <aside class="sp-intel-left">
      <div class="sp-intel-left-header">
        <button class="sp-new-thread" (click)="newThread()">
          <span class="material-icons">add</span>
          New conversation
        </button>
      </div>

      <div class="sp-history-section">
        <div class="sp-history-label">Recent</div>
        <button class="sp-history-item"
                *ngFor="let t of history; trackBy: trackByIdx"
                (click)="openHistoryThread(t)">
          <span class="material-icons">forum</span>
          <div class="sp-history-text">
            <div class="sp-history-title">{{ t.label }}</div>
            <div class="sp-history-preview">{{ t.preview }}</div>
          </div>
        </button>
      </div>
    </aside>

    <!-- ─────────────── CENTRE: CHAT THREAD ─────────────── -->
    <main class="sp-intel-centre">

      <div class="sp-intel-banner">
        <span class="material-icons">auto_awesome</span>
        <span>Ask your repository — claims, policies, members, documents.</span>
      </div>

      <div #threadScroll class="sp-thread-scroll">
        <div *ngFor="let m of messages; trackBy: trackByIdx"
             class="sp-msg"
             [class.sp-msg--user]="m.role === 'user'"
             [class.sp-msg--assistant]="m.role === 'assistant'"
             [class.sp-msg--warning]="m.tone === 'warning'"
             [class.sp-msg--success]="m.tone === 'success'">

          <!-- User avatar -->
          <div class="sp-msg-avatar" *ngIf="m.role === 'user'">
            <span class="material-icons">person</span>
          </div>

          <!-- Assistant avatar -->
          <div class="sp-msg-avatar sp-msg-avatar--ai" *ngIf="m.role === 'assistant'">
            <span class="material-icons">auto_awesome</span>
          </div>

          <div class="sp-msg-bubble">
            <div class="sp-msg-text" *ngIf="!m.pending" [innerHTML]="m.text | markdown"></div>
            <div class="sp-msg-pending" *ngIf="m.pending">
              <span class="sp-dot"></span><span class="sp-dot"></span><span class="sp-dot"></span>
            </div>

            <!-- Citations -->
            <div class="sp-citations" *ngIf="m.citations?.length">
              <div class="sp-citations-label">Sources</div>
              <div class="sp-citation-strip">
                <div class="sp-citation-chip"
                     *ngFor="let c of m.citations; trackBy: trackByIdx"
                     [class.sp-cite--claim]="c.type === 'claim'"
                     [class.sp-cite--policy]="c.type === 'policy'"
                     [class.sp-cite--doc]="c.type === 'document'">
                  <span class="material-icons">
                    {{ c.type === 'claim' ? 'folder_special' :
                       c.type === 'policy' ? 'shield' :
                       c.type === 'document' ? 'description' : 'article' }}
                  </span>
                  <span class="sp-citation-name">{{ c.name }}</span>
                  <span class="sp-citation-snippet" *ngIf="c.snippet"> · {{ c.snippet }}</span>
                </div>
              </div>
            </div>

            <!-- Suggested follow-ups -->
            <div class="sp-followups" *ngIf="m.suggested?.length">
              <button class="sp-followup-chip"
                      *ngFor="let s of m.suggested; trackBy: trackByIdx"
                      (click)="pickSuggestion(s)">
                {{ s.label }}
              </button>
            </div>

            <div class="sp-msg-time">{{ formatTime(m.timestamp) }}</div>
          </div>
        </div>
      </div>

      <!-- Input bar -->
      <div class="sp-input-bar">
        <textarea #inputBox
                  [(ngModel)]="draft"
                  [placeholder]="sector.label('ai.placeholder') || 'Ask about claims, policies, members...'"
                  (keydown)="onKeyDown($event)"
                  rows="1"
                  [disabled]="isSending"></textarea>
        <button class="sp-send-btn"
                (click)="send()"
                [disabled]="isSending || !draft.trim()">
          <span class="material-icons">send</span>
        </button>
      </div>
    </main>

    <!-- ─────────────── RIGHT RAIL: CONTEXT + SUGGESTIONS ─────────────── -->
    <aside class="sp-intel-right">
      <div class="sp-right-header" *ngIf="contextLabel">
        <div class="sp-right-eyebrow">{{ contextType }}</div>
        <div class="sp-right-name">{{ contextLabel }}</div>
      </div>
      <div class="sp-right-header" *ngIf="!contextLabel">
        <div class="sp-right-eyebrow">Context</div>
        <div class="sp-right-name">All claims</div>
      </div>

      <div class="sp-right-section">
        <div class="sp-section-label">
          <span class="material-icons">help_outline</span>
          Try asking
        </div>
        <button class="sp-suggested-chip"
                *ngFor="let q of suggestedQuestions; trackBy: trackByIdx"
                (click)="pickSuggestion(q)">
          {{ q.label }}
        </button>
      </div>

      <div class="sp-right-section sp-right-foot">
        <div class="sp-tip">
          <span class="material-icons">info</span>
          <span>Answers are based on documents and metadata in your repository. Sources are cited under each response.</span>
        </div>
      </div>
    </aside>

  </div>
</div>
